import { render, staticRenderFns } from "./editWorkDraft.vue?vue&type=template&id=562c6274&"
import script from "./editWorkDraft.vue?vue&type=script&lang=js&"
export * from "./editWorkDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports